import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Key } from 'lucide-react';

interface SOPSectionProps {
  instructionNotes?: string;
  accessCode?: string;
}

export const SOPSection = ({ instructionNotes, accessCode }: SOPSectionProps) => {
  const [showAccessCode, setShowAccessCode] = useState(false);

  return (
    <div className="space-y-4">
      {accessCode && (
        <div className="space-y-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => setShowAccessCode(!showAccessCode)}
            className="w-full justify-start"
          >
            <Key className="mr-2 h-4 w-4" />
            {showAccessCode ? 'Ukryj kody dostępu' : 'Pokaż kody dostępu'}
          </Button>
          {showAccessCode ? (
            <div className="bg-muted/50 rounded-lg p-3 text-sm font-mono whitespace-pre-line">
              {accessCode}
            </div>
          ) : null}
        </div>
      )}

      {instructionNotes ? (
        <div className="bg-muted/50 rounded-lg p-4 text-sm leading-relaxed whitespace-pre-line">
          {instructionNotes}
        </div>
      ) : (
        <p className="text-sm text-muted-foreground italic">
          Brak instrukcji dla tego obiektu
        </p>
      )}
    </div>
  );
};
